/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import LookupOptionList from './LookupOptionList';
import masterLabels from '../labels/master_en.json';
import commonLabels from '../../../common/labels/common_en.json';
import { getAllModulesList, getAllParentLabelList, getAllParentTypeList, getAllTypesList, addLookupOptionData, getParentLookupOption, getLookupOption, editLookupOption, resetLookupOption, resetLookupOptionList } from '../actions/masterManagementAction';
import { SET_LOOKUP_OPTIONS } from '../../../common/constants/ActionTypes';

const LookupOptionForm = ({ addLookupOption, setAddLookupOption, setModuleCode, moduleCode, setTypeCode, typeCode, parentType, parentId, setParentType, setParentId, setTextToSearch }) => {
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange"
  });
  let [isChild, setIsChild] = useState(false);

  const onSubmit = (data, addLookupOption, setAddLookupOption) => {

    let requestBody = {
      "lookupOption": {
        "module": addLookupOption && addLookupOption.Mode == 'Edit' ? addLookupOption.moduleCode : data.moduleCode,
        "type": addLookupOption && addLookupOption.Mode == 'Edit' ? addLookupOption.typeCode : data.typeCode,
        "parentId": addLookupOption && addLookupOption.Mode == 'Edit' ? addLookupOption.parentId : parentId,
        "label": data.lookupOptionName,
        "translations": JSON.stringify({ "ma": data.lookupNameMarathi }),
        "abbr": data.lookupOptionAbbr ? data.lookupOptionAbbr : '',
        "isActive": data.isActive
      }
    }
    dispatch(resetLookupOptionList());
    if (addLookupOption.Mode == 'Add') {
      dispatch(addLookupOptionData(requestBody, setAddLookupOption, setModuleCode, setTypeCode, setParentType, setParentId, setTextToSearch));
    }
    else if (addLookupOption.Mode == 'Edit') {
      requestBody.lookupOption.id = addLookupOption.id;
      dispatch(editLookupOption(requestBody, setAddLookupOption, setModuleCode, setTypeCode, setParentType, setParentId, setTextToSearch));
    }
  }

  useEffect(() => {
    if (addLookupOption && addLookupOption.Mode == 'Add') {
      dispatch(resetLookupOptionList());

    }
    dispatch(getAllModulesList());
    setModuleCode(false);
    setTypeCode(false);
    setParentType(false);
    setParentId(null);
    addLookupOption.Mode == "Edit" && addLookupOption.id > 0 && addLookupOption.parentId > 0 && setIsChild(true);
    addLookupOption.Mode == "Edit" && addLookupOption.id > 0 && addLookupOption.parentId > 0 && dispatch(getAllParentTypeList(addLookupOption.moduleCode));
    addLookupOption.Mode == "Edit" && addLookupOption.id > 0 && addLookupOption.parentId > 0 && dispatch(getParentLookupOption(addLookupOption.parentId));
    addLookupOption.Mode == "Edit" && addLookupOption.id > 0 && dispatch(getLookupOption(addLookupOption.id));


    dispatch({
      type: SET_LOOKUP_OPTIONS,
      payload: {},
    });
    // eslint-disable-next-line
  }, [])
  const onModuleChange = (e) => {
    let moduleCode = e.target.value;
    setModuleCode(moduleCode);
    dispatch(getAllTypesList(moduleCode));
    dispatch(getAllParentTypeList(moduleCode));
  }
  const onParentTypeChange = (e) => {
    setParentType(e.target.value);
    dispatch(getAllParentLabelList(moduleCode, e.target.value));
  }

  const { modulesList, typesList, parentLabelsList, lookupOptionData, parentLookupData, parentTypeList } = useSelector((state) => state.masterManagementReducer, shallowEqual);

  const onCancelButton = () => {
    setAddLookupOption({ "Mode": false });
    setModuleCode(false);
    setTypeCode(false);
    setTextToSearch('');
    setParentType(false);
    setParentId(null);
    dispatch(resetLookupOption());
    dispatch(resetLookupOptionList());
  }

  return addLookupOption.Mode == false ? (
    <div>
      <LookupOptionList
        setAddLookupOption={setAddLookupOption}
      />
    </div>
  ) : (
    <div>
      <form>
        <div className="border border-light text-center w-100 p-5" >
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-6'>
                <h4><p className='float-left'>{addLookupOption.Mode == 'Add' ? masterLabels.lookupOptionForm.Add_New_Lookup_Option_Label : masterLabels.lookupOptionForm.Update_New_Lookup_Option_Label}</p></h4>
              </div>
            </div>
          </div>
          <br />
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-2'>

                <label className="font-weight-bold float-left">{masterLabels.lookupOptionForm.Modules}<span className="redColor">*</span></label>
                <select
                  className='form-control'
                  name="moduleCode"
                  onInput={onModuleChange}
                  ref={register({ required: true })}
                  defaultValue={addLookupOption && addLookupOption.Mode == 'Edit' && addLookupOption.moduleCode}
                  disabled={addLookupOption && addLookupOption.Mode == 'Edit' && true}
                >
                  <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                  {modulesList && modulesList.lookupOptionList && modulesList.lookupOptionList.length > 0 && modulesList.lookupOptionList.map((element, index) =>
                    <option key={index} value={element.module}>{element.module}</option>
                  )}
                </select>
                {_.get("moduleCode.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
              </div>
              <div className='col-md-2'>
                <label className="font-weight-bold float-left">{masterLabels.lookupOptionForm.Types}<span className="redColor">*</span></label>
                <select
                  className='form-control'
                  name="typeCode"
                  ref={register({ required: true })}
                  defaultValue={addLookupOption && addLookupOption.Mode == 'Edit' && addLookupOption.typeCode}
                  onInput={(event) => setTypeCode(event.target.value)}
                  disabled={addLookupOption && addLookupOption.Mode == 'Edit' && true}
                >
                  <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                  {typesList && typesList.lookupOptionList && typesList.lookupOptionList.length > 0 && typesList.lookupOptionList.map((element, index) =>
                    <option key={index} value={element.type}>{element.type}</option>
                  )}
                </select>
                {_.get("typeCode.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
              </div>
              <div className='col-md-2'>
                <label className='font-weight-bold float-left' >{masterLabels.lookupOptionForm.Name}<span className="redColor">*</span></label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="lookupOptionName"
                  placeholder={masterLabels.lookupOptionForm.Name}
                  ref={register({ required: true, maxLength: 300 })}
                  defaultValue={lookupOptionData && lookupOptionData.lookupOption && lookupOptionData.lookupOption.label}
                />
                {_.get("lookupOptionName.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
                {_.get("lookupOptionName.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_300}</p>
                )}
              </div>
              <div className='col-md-2'>
                <label className='font-weight-bold float-left' >{masterLabels.lookupOptionForm.Abbr}</label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="lookupOptionAbbr"
                  placeholder={masterLabels.lookupOptionForm.Abbr}
                  ref={register({ maxLength: 300 })}
                  defaultValue={lookupOptionData && lookupOptionData.lookupOption && lookupOptionData.lookupOption.abbr}
                />

                {_.get("lookupOptionAbbr.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_300}</p>
                )}
              </div>
              <div className='col-md-1'>
                <label className='float-left font-weight-bold text-left w-100'>{masterLabels.lookupOptionForm.isChild}?&nbsp;&nbsp;</label>
                <input
                  className='float-center text-left'
                  type="checkbox"
                  name="isParent"
                  value={true}
                  defaultChecked={addLookupOption && addLookupOption.parentId && true}
                  onClick={() => { setIsChild(!isChild) }}
                  ref={register({})}
                  disabled={addLookupOption && addLookupOption.Mode == 'Edit' && true}
                                      
                />
              </div>
              <div className='col-md-1'>
                <label className='float-left font-weight-bold text-left w-100'>{masterLabels.lookupOptionForm.isActive}?&nbsp;&nbsp;</label>
                <input
                  className='float-center text-left'
                  type="checkbox"
                  name="isActive"
                  value={true}
                  defaultChecked={lookupOptionData && lookupOptionData.lookupOption && lookupOptionData.lookupOption.isActive && true}
                  ref={register({})}
                                      
                />
              </div>
            </div>
            {isChild &&
              <div className='row'>
                <div className='col-md-2'>
                  <label className="font-weight-bold float-left mb-2">{masterLabels.lookupOptionForm.Parent_Types}</label>
                  <select
                    className='form-control'
                    name="parentType"
                    onChange={onParentTypeChange}
                    defaultValue={addLookupOption && addLookupOption.Mode == 'Edit' && parentLookupData && parentLookupData.lookupOption && parentLookupData.lookupOption.type}
                    disabled={addLookupOption && addLookupOption.Mode == 'Edit' && true}
                  >
                    {addLookupOption && addLookupOption.Mode == 'Edit' ?
                      <option key={0} value={parentLookupData && parentLookupData.lookupOption && parentLookupData.lookupOption.type}>{parentLookupData && parentLookupData.lookupOption && parentLookupData.lookupOption.type}</option>
                      :
                      <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                    }
                    {parentTypeList && parentTypeList.lookupOptionList && parentTypeList.lookupOptionList.length > 0 && parentTypeList.lookupOptionList.map((element, index) =>
                      <option key={index} value={element.type}>{element.type}</option>
                    )}
                  </select>

                </div>
                <div className='col-md-3'>
                  <label className="font-weight-bold float-left mb-2">{masterLabels.lookupOptionForm.Parent_Labels}</label>
                  <select
                    className='form-control'
                    name="parentId"
                    defaultValue={addLookupOption && addLookupOption.Mode == 'Edit' && addLookupOption.parentId}
                    onChange={(event) => setParentId(event.target.value)}
                    disabled={addLookupOption && addLookupOption.Mode == 'Edit' && true}
                  >
                    {addLookupOption && addLookupOption.Mode == 'Edit' ?
                      <option key={0} value={parentLookupData && parentLookupData.lookupOption && parentLookupData.lookupOption.id}>{parentLookupData && parentLookupData.lookupOption && parentLookupData.lookupOption.label}</option>
                      :
                      <option key={0} value="">{commonLabels.COMBO_SELECT}</option>}
                    {parentLabelsList && parentLabelsList.lookupOptionList && parentLabelsList.lookupOptionList.length > 0 && parentLabelsList.lookupOptionList.map((element, index) =>
                      <option key={index} value={element.id}>{element.label}</option>
                    )}
                  </select>

                </div>


              </div>}
            <div className="row mt-5">
              <div className="col-md-10 d-flex justify-content-end">
                <button type="button" className="btn btn-secondary" onClick={() => onCancelButton()}>
                  {commonLabels.BUTTONS.CANCEL}
                </button>
                <button type="submit" className=" btn btn-primary custom_button  ms-2  " onClick={handleSubmit((e) => { onSubmit(e, addLookupOption, setAddLookupOption); })}>
                  {commonLabels.BUTTONS.SAVE}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default LookupOptionForm;